export default "__VITE_ASSET__BKMGoETi__"